module.exports = __webpack_public_path__ + "static/media/26.b431ec76.webp";